@if (mode === 'add') {
<div pplFocusTrap>
  <div class="ppl-mt20">
    <form nz-form nz-row [formGroup]="fmsForm" class="ppl-p0">
      <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fmsMode">
            FMS Model <span>*</span>
          </nz-form-label>
          <nz-form-control class="ppl-form-control">
            <div [class.error]="fmsForm.get('fmsMode')?.invalid && fmsForm.get('fmsMode')?.touched">
              <ppl-dropdown-select
                formControlName="fmsMode"
                id="fmsMode"
                placeholder="Select FMS Model"
                [options]="fmsModelOptions"
                [optionLabel]="'lkpValueName'"
                [optionValue]="'lkpValueCode'">
              </ppl-dropdown-select>
            </div>
            @if (fmsForm.get('fmsMode')?.invalid && fmsForm.get('fmsMode')?.touched) {
              <span class="pl-1 error-message">FMS Model is required</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>

      <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="startDate" >
            Start Date <span>*</span>
          </nz-form-label>
          <nz-form-control class="ppl-form-control">
            <ppl-date-picker
              formControlName="startDate"
              id="startDate"
              [showIcon]="true"
              placeholder="mm/dd/yyyy"
              dateFormat="mm/dd/yy"
              [yearRange]="'1900:2050'"
              [iconDisplay]="'input'"
              inputId="fmsStartDate"
              [panelStyleClass]="'custom-calendar-panel'"
              [minDate]="minStartDate"
              [styleClass]="fmsForm.get('startDate')?.invalid && fmsForm.get('startDate')?.touched ? 'error' : ''">
            </ppl-date-picker>
            @if (fmsForm.get('startDate')?.invalid && fmsForm.get('startDate')?.touched) {
              @if (fmsForm.get('startDate')?.errors?.['required']) {
                <span class="pl-1 error-message">Start Date is required</span>
              } @else if (fmsForm.get('startDate')?.errors?.['minStartDate']) {
                <span class="pl-1 error-message">Start Date cannot be earlier than the latest record's start date</span>
              }
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
    </form>
  </div>

  @if (errorMessage) {
    <div class="w-100 alert alert-danger custom-message">{{ errorMessage }}</div>
  }

  <div class="custom-row">
    <ppl-button
      label="Cancel"
      icon="fa fa-ban"
      [customClass]="'alt-button'"
      [iconPosition]="'left'"
      (click)="cancel()">
    </ppl-button>
    <ppl-button
      label="Save"
      icon="fa fa-floppy-o"
      [customClass]="'alt-button'"
      [iconPosition]="'left'"
      (click)="save()"
      *authorize="[pageId, tabId, 'FmsData', 'section', 'edit']">
    </ppl-button>
  </div>
</div>
} @else {
  @if (!readOnly) {
    <div class="custom-row">
      <div class="mr-2">
        <ppl-button
          label="Add FMS Model"
          icon="fa fa-plus"
          [customClass]="'ghost-button'"
          [iconPosition]="'left'"
          (click)="add()"
          *authorize="[pageId, tabId, 'FmsData', 'section', 'edit']">
        </ppl-button>
      </div>
    </div>
  }

  @if (gridData.length > 0) {
    <ppl-list-table
      [disableSort]="true"
      [disableSearch]="true"
      [enableActions]="false"
      [data]="gridData"
      [disableSelection]="true"
      [cols]="cols"
      [gridTitle]="false"
      [pagination]="false"
      [loadPage]="true">
    </ppl-list-table>
  } @else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
  }
}
